import { Record as record } from 'immutable';

import { construct, fields } from '../helpers/LinkMapper';

const defaults = {
        id: null,
        message: null
};

class CancellationReason extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(CancellationReason, json, {
            id: fields.number,
            message: fields.string
        });
    }
}

export default CancellationReason;
